import { cardsList as cardsListAT } from '../cards-bank-config/cards-list-config/AT';
import { cardsList as cardsListBase } from '../cards-bank-config/cards-list-config/base';
import { cardsList as cardsListCZ } from '../cards-bank-config/cards-list-config/CZ';
import { cardsList as cardsListRO } from '../cards-bank-config/cards-list-config/RO';
import { cardsList as cardsListSK } from '../cards-bank-config/cards-list-config/SK';
import { creditCardLimitChange as creditCardLimitChangeAT } from '../cards-credit-config/cards-limit-change-config/AT';
import { creditCardLimitChange as creditCardLimitChangeBase } from '../cards-credit-config/cards-limit-change-config/base';
import { creditCardLimitChange as creditCardLimitChangeCZ } from '../cards-credit-config/cards-limit-change-config/CZ';
import { creditCardLimitChange as creditCardLimitChangeRO } from '../cards-credit-config/cards-limit-change-config/RO';
import { creditCardLimitChange as creditCardLimitChangeSK } from '../cards-credit-config/cards-limit-change-config/SK';
import { creditCardLimitInfo as creditCardLimitInfoAT } from '../cards-credit-config/card-limit-info-config/AT';
import { creditCardLimitInfo as creditCardLimitInfoBase } from '../cards-credit-config/card-limit-info-config/base';
import { cardLock as cardLockAT } from '../card-lock-config/AT';
import { cardLock as cardLockBase } from '../card-lock-config/base';
import { cardLock as cardLockHR } from '../card-lock-config/HR';
import { cardLock as cardLockSK } from '../card-lock-config/SK';
import { cardLockAndReplace as cardLockAndReplaceAT } from '../card-lock-and-replace-config/AT';
import { cardLockAndReplace as cardLockAndReplaceBase } from '../card-lock-and-replace-config/base';
import { creditCardContentBox as creditCardContentBoxBase } from '../credit-card-content-box/base';
import { creditCardContentBox as creditCardContentBoxAT } from '../credit-card-content-box/AT';
import { creditCardContentBox as creditCardContentBoxHR } from '../credit-card-content-box/HR';
import { creditCardContentBox as creditCardContentBoxRO } from '../credit-card-content-box/RO';
import { creditCardContentBox as creditCardContentBoxSK } from '../credit-card-content-box/SK';
import { creditCardContentBox as creditCardContentBoxHU } from '../credit-card-content-box/HU';
import { creditCardContentBox as creditCardContentBoxCZ } from '../credit-card-content-box/CZ';
import { creditCardContentBox as creditCardContentBoxRS } from '../credit-card-content-box/RS';
import { debitCardContentBox as debitCardContentBoxBase } from '../debit-card-content-box/base';
import { debitCardContentBox as debitCardContentBoxAT } from '../debit-card-content-box/AT';
import { debitCardContentBox as debitCardContentBoxHR } from '../debit-card-content-box/HR';
import { debitCardContentBox as debitCardContentBoxRO } from '../debit-card-content-box/RO';
import { debitCardContentBox as debitCardContentBoxSK } from '../debit-card-content-box/SK';
import { debitCardContentBox as debitCardContentBoxHU } from '../debit-card-content-box/HU';
import { debitCardContentBox as debitCardContentBoxCZ } from '../debit-card-content-box/CZ';
import { debitCardContentBox as debitCardContentBoxRS } from '../debit-card-content-box/RS';
import { cardBlocking as cardBlockingAT } from '../card-blocking-config/AT';
import { cardBlocking as cardBlockingBase } from '../card-blocking-config/base';
import { cardBlocking as cardBlockingRO } from '../card-blocking-config/RO';
import { cardBlocking as cardBlockingSK } from '../card-blocking-config/SK';
import { bankCardHeader as bankCardHeaderBase } from '../cards-bank-config/card-header-config/base';
import { bankCardHeader as bankCardHeaderCZ } from '../cards-bank-config/card-header-config/CZ';
import { bankCardHeader as bankCardHeaderHR } from '../cards-bank-config/card-header-config/HR';
import { bankCardHeader as bankCardHeaderHU } from '../cards-bank-config/card-header-config/HU';
import { bankCardHeader as bankCardHeaderRO } from '../cards-bank-config/card-header-config/RO';
import { bankCardHeader as bankCardHeaderRS } from '../cards-bank-config/card-header-config/RS';
import { bankCardHeader as bankCardHeaderSK } from '../cards-bank-config/card-header-config/SK';
import { cardCancellation as cardCancellationAT } from '../card-cancellation-config/AT';
import { cardCancellation as cardCancellationBase } from '../card-cancellation-config/base';
import { installments as installmentsBase } from '../installments-config/base';
import { installments as installmentsHR } from '../installments-config/HR';
import { installments as installmentsHU } from '../installments-config/HU';
import { accountLinkage as accountLinkageBase } from '../cards-settings-config/account-linkage-config/base';
import { cardDetails as cardDetailsAT } from '../cards-settings-config/card-details-config/AT';
import { cardDetails as cardDetailsBase } from '../cards-settings-config/card-details-config/base';
import { cardDetails as cardDetailsCZ } from '../cards-settings-config/card-details-config/CZ';
import { cardDetails as cardDetailsHR } from '../cards-settings-config/card-details-config/HR';
import { cardDetails as cardDetailsHU } from '../cards-settings-config/card-details-config/HU';
import { cardDetails as cardDetailsRO } from '../cards-settings-config/card-details-config/RO';
import { cardDetails as cardDetailsSK } from '../cards-settings-config/card-details-config/SK';
import { cardDetails as cardDetailsRS } from '../cards-settings-config/card-details-config/RS';
import { cardFees as cardFeesBase } from '../cards-credit-config/card-fees-config/base';
import { cardFees as cardFeesCZ } from '../cards-credit-config/card-fees-config/CZ';
import { authorizedCardHeaderDetails as authorizedCardHeaderDetailsBase } from '../authorized-card-header-details-config/base';
import { authorizedCardHeaderDetails as authorizedCardHeaderDetailsCZ } from '../authorized-card-header-details-config/CZ';
import { orderReplacementCard as orderReplacementCardBase } from '../order-replacement-card-config/base';
import { orderReplacementCard as orderReplacementCardCZ } from '../order-replacement-card-config/CZ';
import { cardActivation as cardActivationBase } from '../card-activation-config/base';
import { cardActivation as cardActivationCZ } from '../card-activation-config/CZ';
import { cardActivation as cardActivationHU } from '../card-activation-config/HU';
import { cardActivation as cardActivationSK } from '../card-activation-config/SK';
import { cardDelivery as cardDeliveryBase } from '../card-services-delivery-settings-card-config/base';
import { cardDelivery as cardDeliveryCZ } from '../card-services-delivery-settings-card-config/CZ';
import { cardDelivery as cardDeliveryRO } from '../card-services-delivery-settings-card-config/RO';
import { pinDelivery as pinDeliveryBase } from '../card-services-delivery-settings-pin-config/base';
import { pinDelivery as pinDeliveryRO } from '../card-services-delivery-settings-pin-config/RO';
import { cardLoyaltyProgramExternal as cardLoyaltyProgramExternalAT } from '../card-services-loyalty-external-config/AT';
import { cardLoyaltyProgramExternal as cardLoyaltyProgramExternalBase } from '../card-services-loyalty-external-config/base';
import { cardLoyaltyProgramExternal as cardLoyaltyProgramExternalHR } from '../card-services-loyalty-external-config/HR';
import { cardMigrationExternal as cardMigrationExternalAT } from '../card-services-migration-external-config/AT';
import { cardMigrationExternal as cardMigrationExternalBase } from '../card-services-migration-external-config/base';
import { creditCardReissueExternal as creditCardReissueExternalAT } from '../card-services-reissue-external-config/AT';
import { creditCardReissueExternal as creditCardReissueExternalBase } from '../card-services-reissue-external-config/base';
import { creditCardRepaymentMethodChangeExternal as creditCardRepaymentMethodChangeExternalAT } from '../card-services-repayment-method-change-external-config/AT';
import { creditCardRepaymentMethodChangeExternal as creditCardRepaymentMethodChangeExternalBase } from '../card-services-repayment-method-change-external-config/base';
import { creditCardCreditLimitChangeExternal as creditCardCreditLimitChangeExternalAT } from '../card-services-credit-limit-change-external-config/AT';
import { creditCardCreditLimitChangeExternal as creditCardCreditLimitChangeExternalBase } from '../card-services-credit-limit-change-external-config/base';
import { displayPin as displayPinBase } from '../card-services-display-pin-config/base';
import { displayPin as displayPinCZ } from '../card-services-display-pin-config/CZ';
import { installmentsActivation as installmentsActivationAT } from '../installments-activation-config/AT';
import { installmentsActivation as installmentsActivationBase } from '../installments-activation-config/base';
import { installmentsActivation as installmentsActivationHU } from '../installments-activation-config/HU';
import { limits as limitsBase } from '../card-limits-combined-config/base';
import { limits as limitsHU } from '../card-limits-combined-config/HU';
import { limitsChange as limitsChangeBase } from '../card-limits-change-config/base';
import { limitsChange as limitsChangeAT } from '../card-limits-change-config/AT';
import { limitsChange as limitsChangeCZ } from '../card-limits-change-config/CZ';
import { limitsChange as limitsChangeHR } from '../card-limits-change-config/HR';
import { limitsChange as limitsChangeHU } from '../card-limits-change-config/HU';
import { limitsChange as limitsChangeRO } from '../card-limits-change-config/RO';
import { limitsChange as limitsChangeRS } from '../card-limits-change-config/RS';
import { limitsChange as limitsChangeSK } from '../card-limits-change-config/SK';
import { reprintPin as reprintPinBase } from '../card-services-reprint-pin/base';
import { reprintPin as reprintPinHU } from '../card-services-reprint-pin/HU';
import { reprintPin as reprintPinRO } from '../card-services-reprint-pin/RO';
import { creditShared as creditSharedAT } from '../shared-credit-config/AT';
import { creditShared as creditSharedBase } from '../shared-credit-config/base';
import { creditShared as creditSharedCZ } from '../shared-credit-config/CZ';
import { creditShared as creditSharedHR } from '../shared-credit-config/HR';
import { creditShared as creditSharedHU } from '../shared-credit-config/HU';
import { creditShared as creditSharedRO } from '../shared-credit-config/RO';
import { creditShared as creditSharedSK } from '../shared-credit-config/SK';
import { creditShared as creditSharedRS } from '../shared-credit-config/RS';

export const CardsBankListFeatureConfig = {
    AT: cardsListAT,
    base: cardsListBase,
    CZ: cardsListCZ,
    RO: cardsListRO,
    SK: cardsListSK,
};

export const CardsCreditLimitChangeFeatureConfig = {
    AT: creditCardLimitChangeAT,
    base: creditCardLimitChangeBase,
    CZ: creditCardLimitChangeCZ,
    RO: creditCardLimitChangeRO,
    SK: creditCardLimitChangeSK,
};

export const CardsCreditLimitInfoFeatureConfig = {
    AT: creditCardLimitInfoAT,
    base: creditCardLimitInfoBase,
};

export const CardLockFeatureConfig = {
    AT: cardLockAT,
    base: cardLockBase,
    HR: cardLockHR,
    SK: cardLockSK,
};

export const CardLockAndReplaceFeatureConfig = {
    AT: cardLockAndReplaceAT,
    base: cardLockAndReplaceBase,
};

export const CreditCardContentBoxFeatureConfig = {
    base: creditCardContentBoxBase,
    AT: creditCardContentBoxAT,
    HR: creditCardContentBoxHR,
    RO: creditCardContentBoxRO,
    SK: creditCardContentBoxSK,
    HU: creditCardContentBoxHU,
    CZ: creditCardContentBoxCZ,
    RS: creditCardContentBoxRS,
};

export const DebitCardContentBoxFeatureConfig = {
    base: debitCardContentBoxBase,
    AT: debitCardContentBoxAT,
    HR: debitCardContentBoxHR,
    RO: debitCardContentBoxRO,
    SK: debitCardContentBoxSK,
    HU: debitCardContentBoxHU,
    CZ: debitCardContentBoxCZ,
    RS: debitCardContentBoxRS,
};

export const CardCancellationFeatureConfig = {
    AT: cardCancellationAT,
    base: cardCancellationBase,
};

export const CardBlockingFeatureConfig = {
    AT: cardBlockingAT,
    base: cardBlockingBase,
    RO: cardBlockingRO,
    SK: cardBlockingSK,
};

export const CardBankHeaderFeatureConfig = {
    base: bankCardHeaderBase,
    CZ: bankCardHeaderCZ,
    HR: bankCardHeaderHR,
    HU: bankCardHeaderHU,
    RO: bankCardHeaderRO,
    RS: bankCardHeaderRS,
    SK: bankCardHeaderSK,
};

export const InstallmentsFeatureConfig = {
    base: installmentsBase,
    HR: installmentsHR,
    HU: installmentsHU,
};

export const AccountLinkageFeatureConfig = {
    base: accountLinkageBase,
};

export const CardsSettingsCardDetailsFeatureConfig = {
    AT: cardDetailsAT,
    base: cardDetailsBase,
    CZ: cardDetailsCZ,
    HR: cardDetailsHR,
    HU: cardDetailsHU,
    RO: cardDetailsRO,
    SK: cardDetailsSK,
    RS: cardDetailsRS,
};

export const CardsCreditCardFeesFeatureConfig = {
    base: cardFeesBase,
    CZ: cardFeesCZ,
};

export const AuthorizedCardHeaderDetailsFeatureConfig = {
    base: authorizedCardHeaderDetailsBase,
    CZ: authorizedCardHeaderDetailsCZ,
};

export const OrderReplacementCardFeatureConfig = {
    base: orderReplacementCardBase,
    CZ: orderReplacementCardCZ,
};

export const CardActivationFeatureConfig = {
    base: cardActivationBase,
    CZ: cardActivationCZ,
    HU: cardActivationHU,
    SK: cardActivationSK,
};

export const CardDeliveryFeatureConfig = {
    base: cardDeliveryBase,
    CZ: cardDeliveryCZ,
    RO: cardDeliveryRO,
};

export const PinDeliveryFeatureConfig = {
    base: pinDeliveryBase,
    RO: pinDeliveryRO,
};

export const CardLoyaltyProgramExternalFeatureConfig = {
    AT: cardLoyaltyProgramExternalAT,
    base: cardLoyaltyProgramExternalBase,
    HR: cardLoyaltyProgramExternalHR,
};

export const CardMigrationExternalFeatureConfig = {
    AT: cardMigrationExternalAT,
    base: cardMigrationExternalBase,
};

export const CreditCardReissueExternalFeatureConfig = {
    AT: creditCardReissueExternalAT,
    base: creditCardReissueExternalBase,
};

export const CreditCardRepaymentMethodChangeExternalFeatureConfig = {
    AT: creditCardRepaymentMethodChangeExternalAT,
    base: creditCardRepaymentMethodChangeExternalBase,
};

export const cardsCreditLimitChangeExternalFeatureConfig = {
    AT: creditCardCreditLimitChangeExternalAT,
    base: creditCardCreditLimitChangeExternalBase,
};

export const DisplayPinFeatureConfig = {
    base: displayPinBase,
    CZ: displayPinCZ,
};

export const InstallmentsActivationFeatureConfig = {
    AT: installmentsActivationAT,
    base: installmentsActivationBase,
    HU: installmentsActivationHU,
};

export const CardLimitsCombinedFeatureConfig = {
    base: limitsBase,
    HU: limitsHU,
};

export const CardLimitsChangeFeatureConfig = {
    base: limitsChangeBase,
    AT: limitsChangeAT,
    CZ: limitsChangeCZ,
    HR: limitsChangeHR,
    HU: limitsChangeHU,
    RO: limitsChangeRO,
    RS: limitsChangeRS,
    SK: limitsChangeSK,
};

export const ReprintPinFeatureConfig = {
    base: reprintPinBase,
    HU: reprintPinHU,
    RO: reprintPinRO,
};

export const CreditSharedFeatureConfig = {
    AT: creditSharedAT,
    base: creditSharedBase,
    CZ: creditSharedCZ,
    HR: creditSharedHR,
    HU: creditSharedHU,
    RO: creditSharedRO,
    SK: creditSharedSK,
    RS: creditSharedRS,
};
